import Vue from 'vue'
import View from './View'
import Edit from './Edit'

Vue.component('RentShowForm', View)
Vue.component('RentEditForm', Edit)
